const emojiPickerStyles = {
  bottom: '100%',
  left: 0,
  position: 'absolute',
};

export default emojiPickerStyles;
